import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import {
    renderCellDate,
    renderTextColumn,
} from "src/utils/table-render-functions"
import { formatStringToFloatDecimalCase } from "src/utils/format-decimal"

export const getEmissionSummaryModalConfig = ({
    admin,
    stateRating,
    ratingActions,
    stateDebtorEmission,
    debtorEmissionActions,
    lastEventCreditEmissionState,
    lastEventCreditEmissionActions,
    lastEventCreditDebtorState,
    lastEventCreditDebtorActions,
    stateIndexLiquidity,
    indexLiquidityActions,
    lastBusinessState,
    lastBusinessActions,
    statePriceProcess,
    priceProcessActions,
}) => ({
    last_emission: {
        title: "Histórico Rating Emissão",
        btnAddTitle: "ADICIONAR RATING",
        loadData: async () => await ratingActions.loadTableRows(),
        table: stateRating.table,
        rowHeight: "auto",
        columns: [
            {
                field: "DataReferencia",
                typeComponent: "date",
                headerName: "Data Referencia",
                minWidth: 130,
                editable: admin,
                renderCell: renderCellDate,
            },
            {
                field: "DataValidade",
                typeComponent: "date",
                headerName: "Data Validade",
                minWidth: 130,
                editable: admin,
                renderCell: renderCellDate,
            },
            {
                field: "Fonte",
                headerName: "Fonte",
                minWidth: 100,
                editable: admin,
            },
            {
                field: "ScoreRating",
                headerName: "Score Rating",
                minWidth: 100,
                editable: admin,
            },
            {
                field: "Rating",
                headerName: "Rating",
                minWidth: 100,
                editable: admin,
            },
            {
                field: "Sinal",
                headerName: "Sinal",
                minWidth: 100,
                editable: admin,
            },
            {
                field: "Perspectiva",
                headerName: "Perspectiva",
                minWidth: 100,
                editable: admin,
            },
            {
                field: "Observacao",
                headerName: "Observação",
                minWidth: stateRating.minWidthObservacao,
                editable: admin,
                renderCell: renderTextColumn,
            },
            {
                field: "AnaliseCreditoEmissao",
                headerName: "Análise Crédito Emissão",
                minWidth: stateRating.minWidthAnaliseCredito,
                editable: admin,
                renderCell: renderTextColumn,
            },
        ],
        rows: stateRating.rows,
        alert: stateRating.alert,
        actions: {
            addRow: ratingActions.addRow,
            deleteRow: ratingActions.deleteRow,
            updateRow: ratingActions.updateRow,
            closeAlert: ratingActions.closeAlert,
        },
    },

    last_debtor: {
        title: "Histórico Rating Devedor",
        btnAddTitle: "ADICIONAR RATING",
        loadData: async () => await debtorEmissionActions.loadTableRows(),
        table: stateDebtorEmission.table,
        rowHeight: "auto",
        columns: [
            {
                field: "DataReferencia",
                minWidth: 130,
                headerName: "Data Referencia",
                flex: 1,
                editable: admin,
                renderCell: renderCellDate,
            },
            {
                field: "DataValidade",
                minWidth: 130,
                headerName: "Data Validade",
                flex: 1,
                editable: admin,
                renderCell: renderCellDate,
            },
            {
                field: "Fonte",
                minWidth: 100,
                headerName: "Fonte",
                flex: 1,
                editable: admin,
            },
            {
                field: "ScoreRating",
                minWidth: 100,
                headerName: "Score Rating",
                flex: 1,
                editable: admin,
            },
            {
                field: "Rating",
                minWidth: 100,
                headerName: "Rating",
                flex: 1,
                editable: admin,
            },
            {
                field: "Sinal",
                minWidth: 100,
                headerName: "Sinal",
                flex: 1,
                editable: admin,
            },
            {
                field: "Perspectiva",
                minWidth: 100,
                headerName: "Perspectiva",
                flex: 1,
                editable: admin,
            },
            {
                field: "Observacao",
                headerName: "Observação",
                flex: 1,
                minWidth: "fit-content",
                editable: admin,
                renderCell: renderTextColumn,
            },
            {
                field: "AnaliseCreditoDevedor",
                headerName: "Análise Crédito Devedor",
                flex: 1,
                minWidth: "fit-content",
                editable: admin,
                renderCell: renderTextColumn,
            },
        ],
        rows: stateDebtorEmission.rows,
        alert: stateDebtorEmission.alert,
        actions: {
            addRow: debtorEmissionActions.addRow,
            deleteRow: debtorEmissionActions.deleteRow,
            updateRow: debtorEmissionActions.updateRow,
            closeAlert: debtorEmissionActions.closeAlert,
        },
    },

    history_event_credit_emission: {
        title: "Histórico Evento de Crédito Emissão",
        btnAddTitle: "ADICIONAR RATING",
        table: lastEventCreditEmissionState.table,
        rowHeight: "auto",
        loadData: async () =>
            await lastEventCreditEmissionActions.loadTableRows(),
        columns: [
            {
                field: "DataReferencia",
                headerName: "Data Referencia",
                minWidth: 150,
                flex: 1,
                editable: admin,
                renderCell: renderCellDate,
            },
            {
                field: "EventoCreditoEmissao",
                headerName: "Evento",
                flex: 1,
                minWidth: "min-content",
                editable: admin,
                renderCell: renderTextColumn,
            },
            {
                field: "ScoreEvento",
                headerName: "Score Evento",
                editable: admin,
                flex: 1,
                minWidth: 120,
            },
        ],
        rows: lastEventCreditEmissionState.rows,
        alert: lastEventCreditEmissionState.alert,
        actions: {
            addRow: lastEventCreditEmissionActions.addRow,
            deleteRow: lastEventCreditEmissionActions.deleteRow,
            updateRow: lastEventCreditEmissionActions.updateRow,
            closeAlert: lastEventCreditEmissionActions.closeAlert,
        },
    },

    history_event_credit_debtor: {
        title: "Histórico Evento de Crédito Devedor",
        btnAddTitle: "ADICIONAR RATING",
        table: lastEventCreditDebtorState.table,
        rowHeight: "auto",
        loadData: async () =>
            await lastEventCreditDebtorActions.loadTableRows(),
        columns: [
            {
                field: "DataReferencia",
                headerName: "Data Referencia",
                flex: 1,
                editable: admin,
                renderCell: renderCellDate,
            },
            {
                field: "EventoCreditoDevedor",
                headerName: "Evento",
                flex: 1,
                minWidth: "min-content",
                editable: admin,
                renderCell: renderTextColumn,
            },
            {
                field: "ScoreEvento",
                headerName: "Score Evento",
                flex: 1,
                editable: admin,
            },
        ],
        rows: lastEventCreditDebtorState.rows,
        alert: lastEventCreditDebtorState.alert,
        actions: {
            addRow: lastEventCreditDebtorActions.addRow,
            deleteRow: lastEventCreditDebtorActions.deleteRow,
            updateRow: lastEventCreditDebtorActions.updateRow,
            closeAlert: lastEventCreditDebtorActions.closeAlert,
        },
    },

    index_liquidity: {
        title: "Histórico Índice Liquidez",
        btnAddTitle: "ADICIONAR ÍNDICE LIQUIDEZ",
        table: stateIndexLiquidity.table,
        rowHeight: undefined,
        loadData: async () => await indexLiquidityActions.loadTableRows(),
        columns: [
            {
                field: "DataReferencia",
                headerName: "Data Referência",
                flex: 1,
                renderCell: renderCellDate,
            },
            {
                field: "IndiceLiquidez",
                headerName: "Índice Liquidez",
                flex: 1,
            },
        ],
        rows: stateIndexLiquidity.rows,
        alert: stateIndexLiquidity.alert,
        actions: {
            addRow: indexLiquidityActions.addRow,
            deleteRow: indexLiquidityActions.deleteRow,
            updateRow: indexLiquidityActions.updateRow,
            closeAlert: indexLiquidityActions.closeAlert,
        },
    },

    history_last_negocitacions: {
        title: "Histórico Das Últimas Negociações",
        btnAddTitle: "",
        table: lastBusinessState.table,
        disableDeleteRow: true,
        rowHeight: undefined,
        loadData: async () => await lastBusinessActions.loadTableRows(),
        columns: [
            {
                field: "DataReferencia",
                headerName: "Data Referencia",
                flex: 1,
                renderCell: (params) =>
                    dayjs(params.value).format(DATE_FORMAT_SHOW),
            },
            {
                field: "PU_MTM",
                headerName: "PU MTM",
                flex: 1,
                renderCell: (params) =>
                    formatStringToFloatDecimalCase(params.value, 4, 4),
            },
            {
                field: "PercentualPUPAR",
                headerName: "%PUPAR",
                flex: 1,
                renderCell: (params) =>
                    formatStringToFloatDecimalCase(params.value, 2, 2),
            },
            {
                field: "TaxaMTM",
                headerName: "Taxa MTM",
                flex: 1,
                renderCell: (params) =>
                    formatStringToFloatDecimalCase(params.value, 4, 4),
            },
            {
                field: "SpreadCreditoFinal",
                headerName: "Spread Crédito",
                flex: 1,
                renderCell: (params) =>
                    formatStringToFloatDecimalCase(params.value, 4, 4),
            },
            {
                field: "VolumeFinanceiro",
                headerName: "Volume Financeiro",
                flex: 1,
                renderCell: (params) =>
                    formatStringToFloatDecimalCase(params.value, 2, 2),
            },
        ],
        rows: lastBusinessState.rows,
        alert: lastBusinessState.alert,
        actions: {
            updateRow: lastBusinessActions.updateRow,
            closeAlert: lastBusinessActions.closeAlert,
        },
    },

    tax_indicative: {
        title: "Histórico Taxa Indicativa",
        btnAddTitle: "ADICIONAR PREÇOS PROCESSADOS",
        loadData: async () => await priceProcessActions.loadTableRows(),
        table: statePriceProcess.table,
        rowHeight: undefined,
        columns: [
            {
                field: "DataReferencia",
                headerName: "Data Referência",
                flex: 1,
                renderCell: renderCellDate,
                editable: admin,
            },
            {
                field: "TaxaMTM",
                headerName: "Taxa MTM",
                flex: 1,
                editable: admin,
                renderCell: ({ value }) =>
                    formatStringToFloatDecimalCase(value, 3, 3),
            },
            {
                field: "PercentualPUPAR",
                headerName: "Percentual PUPAR",
                flex: 1,
                editable: admin,
                renderCell: ({ value }) =>
                    formatStringToFloatDecimalCase(value, 3, 3),
            },
            {
                field: "SpreadCredito",
                headerName: "Spread Crédito",
                flex: 1,
                editable: admin,
                renderCell: ({ value }) =>
                    formatStringToFloatDecimalCase(value, 3, 3),
            },
        ],
        rows: statePriceProcess.rows,
        alert: statePriceProcess.alert,
        actions: {
            addRow: priceProcessActions.addRow,
            deleteRow: priceProcessActions.deleteRow,
            updateRow: priceProcessActions.updateRow,
            closeAlert: priceProcessActions.closeAlert,
        },
    },
})